module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("brDAX"))).then(() => parcelRequire('hEqeo'));